<!-- 规则 -->
<template>
    <div id='serviceRankingList-rules'>
        <img :src="`https://staticwecom.beautyfarm.com.cn/20260305/ym${$route.query.currentJobTab}.png`" alt="">
        <!-- <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/rule2.jpg" alt="">
        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/rule3.jpg" alt=""> -->
    </div>
</template>

<script>
    export default {
        name: 'ssRules',
        components: {},

        computed: {},

        data() {
            return {
            };
        },

        mounted() { },

        methods: {}
    }

</script>
<style lang='less' scoped>
    #serviceRankingList-rules {
        width: 100%;
        height: 100vh;
        overflow: auto;
        padding-bottom: 20px;
    }

    #serviceRankingList-rules img {
        width: 100%;

    }
</style>